import { Address, CountryAddress, CountryForBilling, StateAddress, CityAddress, DistrictAddress } from './address.model';
import { AddressService } from './address.service';

import { ApiAddresses, ApiAddress, ItxCompanyTO } from '@features/address';
import { DropdownOption } from '@shared/forms/models/input-models/input-dropdown.model';

export const AddressTransformer = {
    addressesFromApi: (apiAddresses: ApiAddresses): Address[] => {
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        const addresses: Address[] = apiAddresses.addresses.map(AddressTransformer.addressFromApi.bind(this));

        return addresses;
    },

    addressFromApi: (apiAddress: ApiAddress): Address => {
        const fullName: string = AddressService.getFullName(
            apiAddress.firstName,
            apiAddress.middleName,
            apiAddress.lastName,
        );
        const currentCompany: ItxCompanyTO = apiAddress.company;

        const address: Address = {
            addressLines: apiAddress.addressLines,
            addressName: apiAddress.addressName,
            addressType: apiAddress.addressType,
            birthdate: apiAddress.birthdate,
            buildingNumber: apiAddress.buildingNumber,
            city: apiAddress.city,
            colony: apiAddress.colony,
            company: currentCompany,
            countryCode: apiAddress.countryCode,
            countryName: apiAddress.countryName,
            description: apiAddress.description,
            district: apiAddress.district,
            districtCode: apiAddress.districtCode,
            digiCode: apiAddress.digiCode,
            documentType: apiAddress.documentType,
            documentTypeCode: apiAddress.documentTypeCode,
            dropPointName: apiAddress.dropPointName,
            dropType: apiAddress.dropType,
            email: apiAddress.email,
            firstName: apiAddress.firstName,
            fullName,
            gender: apiAddress.gender,
            id: apiAddress.id,
            invoice: apiAddress.invoice,
            isBilling: apiAddress.isBilling,
            isCompany: apiAddress.isCompany,
            idDropPoint: apiAddress.idDropPoint,
            idDropPointUser: apiAddress.idDropPointUser,
            lastName: apiAddress.lastName,
            middleName: apiAddress.middleName,
            municipality: apiAddress.municipality,
            phones: apiAddress.phones,
            pec: apiAddress.pec,
            province: apiAddress.province,
            preferred: apiAddress.preferred,
            primaryAddressEmail: apiAddress.primaryAddressEmail,
            primaryAddress: apiAddress.primaryAddress,
            receiverCode: apiAddress.receiverCode,
            stateCode: apiAddress.stateCode,
            state: apiAddress.state,
            stateName: apiAddress.stateName,
            taxCode: apiAddress.taxCode,
            taxCodeCode: apiAddress.taxCodeCode,
            taxRegime: apiAddress.taxRegime,
            taxRegimeCode: apiAddress.taxRegimeCode,
            unitNumber: apiAddress.unitNumber,
            vatin: apiAddress.vatin,
            zipCode: apiAddress.zipCode,
            zoneNumber: apiAddress.zoneNumber,
        };

        return address;
    },

    countriesFromApi: (data: any): CountryAddress[] => {
        const countryAddress: CountryAddress[] = data.countries;

        return countryAddress;
    },

    countriesForBillingFromApi: (data: any): CountryForBilling[] => {
        const countriesForBilling: CountryForBilling[] = data;

        return countriesForBilling;
    },

    countryToDropdownValues: (countryAddress: CountryAddress[]): DropdownOption[] => {
        return countryAddress.map((currentCountryAddress: CountryAddress) => ({
            key: currentCountryAddress.name,
            value: currentCountryAddress.code,
        }));
    },

    countryPrefixToDropdownValues: (countryAddress: CountryAddress[]): DropdownOption[] => {
        return countryAddress.map((currentCountryAddress: CountryAddress) => ({
            key: `${currentCountryAddress.name} (${currentCountryAddress.phonePrefix})`,
            value: currentCountryAddress.code,
        }));
    },

    stateAddressesFromApi: (data: any): StateAddress[] => {
        const stateAddress: StateAddress[] = data.states;

        return stateAddress;
    },

    cityAddressesFromApi: (data: any): CityAddress[] => {
        const cityAddress: CityAddress[] = data.cities;

        return cityAddress;
    },

    districtAddressesFromApi: (data: any): DistrictAddress[] => {
        const districtAddress: DistrictAddress[] = data.districts;

        return districtAddress;
    },

    stateAddressesToDropdownValues: (stateAddress: StateAddress[]): DropdownOption[] => {
        const dropdownOption: DropdownOption[] = stateAddress.map((currentStateAddress: StateAddress) => {
            return {
                key: currentStateAddress.name,
                value: currentStateAddress.code,
            };
        });

        return dropdownOption;
    },

    cityAddressesToDropdownValues: (cityAddress: CityAddress[]): DropdownOption[] => {
        const dropdownOption: DropdownOption[] = cityAddress.map((currentCityAddress: CityAddress) => {
            return {
                key: currentCityAddress.name,
                value: `${currentCityAddress.id.toString()}#${currentCityAddress.name}`,
            };
        });

        return dropdownOption;
    },

    districtAddressesToDropdownValues: (districtAddress: DistrictAddress[]): DropdownOption[] => {
        const dropdownOption: DropdownOption[] = districtAddress.map((currentDistricAddress: DistrictAddress) => {
            return {
                key: currentDistricAddress.name,
                value: `${currentDistricAddress.id.toString()}#${currentDistricAddress.name}`,
            };
        });

        return dropdownOption;
    },
};
